export default __webpack_public_path__ + "static/media/50051823_540375.5657dea9.png";